import React, { useState } from "react";
import {
    Autocomplete,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogContent,
    FormControl,
    FormControlLabel,
    FormGroup,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
// import { ACTIVITY_STATUS } from "../../constants";
import { useEffect } from "react";
import OpaqueLoading from "../../opaqueLoading/opaqueLoading";


const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const StyledDialog = styled(Dialog)`
  // position: relative;
  // max-width: 700px;
  
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
    `;


const ExpenseSubTypeModal = ({ onClose, status, fetchData, propData }) => {
    console.log("propData", propData)

    const [name, setName] = useState("");
    const [category, setCategory] = useState("");
    const [loading, setLoading] = useState(false)
    const [expenseType, setExpenseType] = useState([])
    const [expenseTypeValue, setExpenseTypeValue] = useState("")


    useEffect(() => {
        getExpenseType()
    }, [])

    useEffect(() => {
        if (propData) {
            setName(propData?.name || "");
            setExpenseTypeValue(propData?.expenseTypeId || "")
        }
    }, [propData]);

    const getExpenseType = async () => {
        try {
            setLoading(true);
            let results = await window.Platform.database.getExpenseType();
            console.log("results", results);
            const filteredExpenseTypes = results.data.filter(item => item.subTypeRequired === 1);

        setExpenseType(filteredExpenseTypes);
        // setExpenseType(results.data);
        setLoading(false);
        } catch (error) {
            console.error("ERRORCHECK", error);
            window.NotificationUtils.showError("Error Fetching expense type");
            setLoading(false);
        }
        finally {
            setLoading(false)
        }
    }

    const submitHandler = async () => {
        try {
            setLoading(true)
            // console.log("PLANTCODE",plantcode[0].plant_code__c)

            if (propData) {
                const payload = {
                    name:name,
                    expenseTypeId:expenseTypeValue,
                    id:propData?.id
                }
                // console.log(payload,"updateeeeeeeeeeeeeeeeeee")
                // setLoading(false);
                // return;
                await window.Platform.database.updateExpenseSubType( payload );
                window.NotificationUtils.showSuccess("Expense type updated successfully")
            } else {
                const payload = {
                    name:name,
                    expenseTypeId:expenseTypeValue
                }
                // console.log(payload,"adddddddddddddddddddddddddddddddddd")
                // return;
                await window.Platform.database.addExpenseSubType( payload );
                window.NotificationUtils.showSuccess("Expense type added successfully")
            }

            // setProduct(results.data)
            setLoading(false)
            fetchData()
            onClose()
        }
        catch (err) {
            window.NotificationUtils.showError(err?.message);
            console.log(err);
            setLoading(false)

        }
    };

    return (
        <StyledDialog disableEnforceFocus maxWidth="sm" fullWidth={true} open={true}>
            <StyledDialogContent>
                <ModalHeaderContainer>
                    <Typography variant="h5">{status ? "Add Expense Type" : "Edit  Expense Type"}</Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>
                {/* <DialogContent style={{ padding: "10px", width: 400 }}> */}
                <Stack gap="20px" style={{ padding: "10px" }}>
                    {loading && <OpaqueLoading />}
                    <div>
                        <FormControl style={{ width: "100%" }} sx={{ fontSize: 14 }}>
                            <InputLabel >Select Expense Type</InputLabel>
                            <Select
                                labelId={`ExpenseType`}
                                label="Select Expense Type"
                                value={expenseTypeValue}
                                onChange={(e) => setExpenseTypeValue(e.target.value)}
                            >
                                {expenseType && expenseType?.map((ele, index) => {
                                    return <MenuItem key={index} value={ele?.expenseTypeId}>
                                        {ele?.expenseTypeName}
                                    </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <FormControl style={{ width: "100%" }} sx={{ fontSize: 14 }}>
                            <TextField label="Expense Sub Type" value={name} type="text" fullWidth onChange={(e) => setName(e.target.value)} />
                        </FormControl>
                    </div>
                </Stack>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                    <Button
                        color="primary"
                        variant="contained"
                        onClick={submitHandler}
                        disabled={!name.trim() || !expenseTypeValue}
                    >
                        {propData ? 'Update' : 'Create'}
                    </Button>
                </div>
            </StyledDialogContent>
        </StyledDialog>
    );
};

export default ExpenseSubTypeModal;